import { useToast } from '@chakra-ui/react';
import { Form, Modal, ProductInputSchema, ProductsInput } from 'components';
import { useFormik } from 'formik';
import React from 'react';
import { useStore } from 'store';
import * as Yup from 'yup';
import { OrderRequestDto } from '../../providers/api/formulation-service/product-formulation.api';

export type OrderInputSchema = {
  name: string;
  email: string;
  content: ProductInputSchema[];
};
export function CreateOrderModal(props: {
  isOpen: boolean;
  onCancel: () => void;
  onSubmitted: () => void;
  defaultData?: Partial<OrderInputSchema>;
}) {
  const [_store, dispatch] = useStore();

  const toast = useToast();
  const form = useFormik<OrderInputSchema>({
    initialValues: {
      name: props.defaultData?.name || '',
      email: props.defaultData?.email || '',
      content: props.defaultData?.content || [],
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(),
      email: Yup.string().required(),
      content: Yup.array().min(1, 'Order must have at least 1 product.'),
    }),
    onSubmit: ({ content, ...values }, helpers) => {
      const payload: Omit<OrderRequestDto, 'locationId'> = {
        metadata: {
          customerName: values.name,
          customerEmail: values.email,
          origin: 'ellure/factory',
        },
        content,
      };

      dispatch(
        'orders',
        'createOrder',
        payload,
        () => {
          props.onSubmitted();
          toast({
            title: 'Order created!',
            description: 'The order has been submitted.',
            status: 'success',
            duration: 2500,
            isClosable: true,
          });
        },
        () => {
          helpers.setSubmitting(false);
        },
      );
    },
  });

  React.useEffect(() => {
    if (props.isOpen) {
      form.setSubmitting(false);
    } else {
      form.resetForm();
    }
  }, [props.isOpen]);

  return (
    <Modal
      isOpen={props.isOpen}
      closeOnOverlayClick={false}
      onClose={props.onCancel}
      title='Create production order'
      modalContentStyle={{ maxWidth: '90%', width: '800px' }}
    >
      <Form<OrderInputSchema>
        {...form}
        submitLabel='Create'
        schema={[
          {
            label: 'Customer name',
            name: 'name',
          },
          {
            label: 'Customer email',
            name: 'email',
          },
          {
            label: 'Products',
            name: 'content',
            render: (value, { handleChange }) => <ProductsInput value={value as ProductInputSchema[]} onChange={handleChange} />,
          },
        ]}
      />
    </Modal>
  );
}
